import { render, staticRenderFns } from "./LogsActionsCard.vue?vue&type=template&id=160e3350&"
import script from "./LogsActionsCard.vue?vue&type=script&lang=js&"
export * from "./LogsActionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports